import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import projectKeys from './keyFactory';

const GetProjectById = graphql(`
  query ProjectById($projectId: ID!) {
    # Todo: Move this to a separate query
    me {
      user {
        account {
          features
          pipelines {
            id
            name
            publicId
            colour
            type
            stages {
              id
              publicId
              index
              title
            }
          }
        }
      }
    }
    projectById(id: $projectId) {
      id
      publicId
      reference
      archivedAt
      description
      version
      type
      pipeline {
        id
        publicId
        name
        colour
        stages {
          id
          publicId
          index
          title
        }
      }
      currentPipelineStage {
        id
        publicId
        title
      }
      owner {
        id
        fullName
      }
      tags {
        id
        name
        colour
      }
      totals {
        projectValue {
          value
          currency {
            code
            exponent
          }
        }
        acceptedValue {
          value
          currency {
            code
            exponent
          }
        }
        invoicedValue {
          value
          currency {
            code
            exponent
          }
        }
        sentInvoicedValue {
          value
          currency {
            code
            exponent
          }
        }
        completedPaymentValue {
          value
          currency {
            code
            exponent
          }
        }
      }
      addresses {
        site {
          publicId
          id
          line1
          line2
          city
          country
          postalCode
          fullLocalAddress
          contacts {
            id
            name
            description
            email
            phone
          }
          energyPerformanceCertificates {
            ...CertificateFields
          }
        }
      }
      customer {
        id
        publicId
        name
        contacts {
          id
          publicId
          name
          description
          email
          phone
          isPrimary
        }
        fileSharingSettings {
          attachToEmails
        }
      }
      servicePlanPeriod {
        id
        startsAt
        endsAt
        status
        servicePlanSubscription {
          id
          servicePlan {
            id
            name
          }
        }
      }
      connectionApplications {
        id
        status
        data
        createdAt
        submittedAt
        connectionApplicationStatus
        dnoComments
        createdBy {
          fullName
        }
        submittedBy {
          fullName
        }
        commissioning {
          submittedAt
          commissioningStatus
          dnoComments
          exportMpan
        }
      }
    }
  }
`);

const useGetProjectByIdOverview = (projectId?: string, refetch = false) => {
  const { data, ...rest } = useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.overview(projectId!),
    refetchInterval: refetch && 10_000,
    queryFn: () => {
      return gqlClient.request(GetProjectById, {
        projectId: projectId!,
      });
    },
  });
  return {
    project: data?.projectById,
    data,
    ...rest,
  };
};

export default useGetProjectByIdOverview;
